
import MinimalLayout from 'layout/MinimalLayout';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
import React from 'react'
// import ClientFormSteps from 'views/user-components/pages/profile/client-details/client-form/ClientFormSteps';

const SmartGroupRegister = Loadable(lazy(() => import('views/user-components/pages/company-register/SmartGroupRegister')));
// const SmartGroupActivation = Loadable(lazy(() => import('views/user-components/pages/company-register/SmartGroupActivation')));
const AdvisorAllPersonal = Loadable(lazy(() => import('views/user-components/pages/company-register/AdvisorAllPersonal')));
const ClientFormSteps = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/client-form/ClientFormSteps')));
const AumSummary = Loadable(lazy(() => import('views/common-components/aum-summary/AumSummary')));

let loginType = localStorage.getItem('login_type')
let isEmployerLogin = loginType === '5' ? true : false
let isAdvisorLogin = loginType === 'advisor';

const OtherLoginRoutes = {
    path: '/',
    // element: isUserLogin ? <MinimalLayout /> : <Navigate to={`${partnerName}/signin`} />,
    element: (isEmployerLogin || isAdvisorLogin) ? <MinimalLayout /> : <Navigate to={`/signin`} />,
    children: [
        { path: '/smarter_group_register', element: isEmployerLogin ? <SmartGroupRegister /> : <Navigate to={'/signin'} /> },
        { path: '/advisor_all_personal', element: isAdvisorLogin ? <AdvisorAllPersonal /> : <Navigate to={'/signin'} /> },
        { path: '/advisor/client-form/:id', element: isAdvisorLogin ? <ClientFormSteps /> : <Navigate to={'/signin'} /> },
        { path: '/advisor/aum-summary', element: isAdvisorLogin ? <AumSummary /> : <Navigate to={'/signin'} /> },
    ]
}

export default OtherLoginRoutes
